'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

import type { Blog } from '@eliadmin/core/src/api/blogs/blogs-types';

import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export function FirstBlogCard({ blog, className }: { blog: Blog; className?: string }) {
  const locale = useLocaleStore(state => state.currentLocale);

  let formattedDate;

  try {
    formattedDate = new Date(blog.created_at).toLocaleDateString(locale);
  } catch (error) {
    if (error instanceof RangeError) {
      formattedDate = new Date(blog.created_at).toLocaleDateString('en-US');
    } else {
      throw error;
    }
  }

  return (
    <Link
      prefetch={false}
      href={ROUTES.BLOG_DETAIL({ slug: blog.slug })}
      className={cn(
        'col-span-1 flex w-full flex-col items-start justify-start gap-4 rounded-[24px] bg-primary-foreground px-4 py-[28px] transition-all hover:opacity-85 sm:col-span-2 sm:flex-row sm:justify-between sm:gap-5 md:p-6 lg:gap-6',
        className,
      )}
    >
      <Image
        src={blog?.image?.url ?? '/images/placeholder.png'}
        alt={resolveImageAlt(blog?.image, blog?.name)}
        width={0}
        height={0}
        className="w-full rounded-[8px] object-cover object-center sm:max-w-[300px] md:max-w-[360px] lg:max-w-[564px]"
        sizes="100vw"
      />
      <div className="flex h-full w-full flex-1 flex-grow flex-col items-start justify-between gap-8">
        <div className="flex w-full flex-col items-start justify-start gap-4 sm:gap-5 lg:gap-6">
          <p className="text-sm text-[#707070]">{formattedDate}</p>
          <h5 className="line-clamp-3 w-full text-[22px] font-medium leading-[1.2] text-black sm:text-2xl sm:leading-[1.2] lg:text-[32px] lg:leading-[1.2]">
            {blog.name}
          </h5>
        </div>
        <div
          className={cn(
            'relative flex items-center justify-center gap-2 whitespace-nowrap transition-all hover:opacity-80',
            'ea-contact-card__link',
          )}
        >
          Čítať článok
          <Image
            src={'/images/arrow.svg'}
            alt={'Čítať článok'}
            width={20}
            height={20}
            className="max-h-5 min-h-5 min-w-5 max-w-5 object-contain"
          />
        </div>
      </div>
    </Link>
  );
}
